import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { VoiceReportButton } from "@/components/VoiceReportButton";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { shortDay } from "@/components/MultiDatePicker";
import { recurLabel } from "@/components/RecurringFields";

export function SeriesDays({ job }) {
  const [days, setDays] = useState([]);
  useEffect(() => { api.get(`/jobs/${job.id}/series`).then((r) => setDays(r.data)); }, [job.id, job.status]);
  const rec = job.site?.recurring;
  const shown = rec ? days.filter((d) => d.date >= job.date).slice(0, 12) : days;
  return (
    <div className="space-y-2" data-testid="tech-series-days">
      <p className="text-sm font-medium">{rec ? `Cantiere ripetitivo · ${recurLabel(rec)}` : `Cantiere · giornata ${job.series_index} di ${job.series_total}`}</p>
      {shown.map((d, i) => (
        <Link key={d.id} to={`/tecnico/intervento/${d.id}`} className={`flex items-start gap-2 rounded-xl border px-3 py-2 text-sm ${d.id === job.id ? "border-[#61a229] bg-[#f6faf0]" : ""}`} data-testid={`tech-series-day-${i}`}>
          {d.status === "completato" ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#61a229]" /> : <Circle className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" />}
          <span className="flex-1"><span className="capitalize">{shortDay(d.date)}</span> · {d.start}–{d.end}
            {d.day_log && <span className="block text-xs text-slate-500">{d.day_log.notes}</span>}</span>
        </Link>
      ))}
    </div>
  );
}

export function DayDoneForm({ job, onDone }) {
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const report = job.site?.daily_report !== false;
  const submit = async () => {
    if (report && notes.trim().length < 3) return toast.error("Scrivi cosa è stato fatto oggi");
    setBusy(true);
    try {
      onDone((await api.post(`/jobs/${job.id}/day-done`, { notes: notes.trim() })).data);
      toast.success("Giornata registrata");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-3" data-testid="day-done-form">
      <p className="text-xs text-slate-500">Il rapporto finale con ore totali, ricambi, sconto e firma si compila l'ultimo giorno del cantiere.</p>
      <div className="space-y-2"><div className="flex flex-wrap items-center justify-between gap-2"><Label>Lavoro svolto oggi {report ? "*" : "(facoltativo)"}</Label>
        <VoiceReportButton kind="giornata" value={notes} onText={setNotes} testid="day-done-voice" /></div>
        <Textarea rows={6} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Es. posa tubazioni piano terra, predisposizione split" data-testid="day-done-notes-input" /></div>
      <Button onClick={submit} disabled={busy} className="h-12 w-full rounded-full" data-testid="day-done-submit-button">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Segna giornata svolta
      </Button>
    </div>
  );
}
